import { f } from '@utils/nextForms';
import { z } from 'zod';

export const BaseBookingInquiryCargoForm = z.object({
  name: f.withEnglishRegex(z.string()).min(1),
  num: z.number().int().positive(),
  pickup_address_index: z.number(),
});

export type BaseBookingInquiryCargoForm = z.infer<typeof BaseBookingInquiryCargoForm>;

export const BookingInquiryLWHCargoForm = BaseBookingInquiryCargoForm.extend({
  tag: z.literal('LWH'),
  length: z.number().positive(),
  width: z.number().positive(),
  height: z.number().positive(),
  weight: z.number().positive(),
});

export type BookingInquiryLWHCargoForm = z.infer<typeof BookingInquiryLWHCargoForm>;

export const BookingInquiryWVCargoForm = BaseBookingInquiryCargoForm.extend({
  tag: z.literal('WV'),
  total_volume: z.number().positive(),
  total_weight: z.number().positive(),
});

export type BookingInquiryWVCargoForm = z.infer<typeof BookingInquiryWVCargoForm>;

export const BookingInquiryCargoForm = z.discriminatedUnion('tag', [
  BookingInquiryLWHCargoForm,
  BookingInquiryWVCargoForm,
]);

export type BookingInquiryCargoForm = z.infer<typeof BookingInquiryCargoForm>;
